// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"512":"53e55b87","725":"5d3d7691","766":"70da0165"}[chunkId] + ".js";
};